export const HEADING = 'Popular crypto assets';

export const SUBHEADING = 'Networks, Stablecoins, DeFi, Memecoins';

export const SEE_ALL_HREF = 'https://trading.republic.com/trade';

/**
 * Where a card sends you. The trade index for now — the feed carries no
 * per-asset destination, so every tile shares this one rather than guessing at
 * a deep-link shape.
 */
// TODO: https://linear.app/republic/issue/USMKT-2166/fe-setup-opportunities-page - point each card at its own asset page
export const CARD_HREF = SEE_ALL_HREF;

/**
 * 248px at `md` per the design. The mobile value is smaller so a peek of the
 * next card stays visible at 375px, where the content width leaves too little
 * room for a 248px slide plus its neighbour.
 */
export const SLIDE_WIDTH = { base: '13.5rem', md: '15.5rem' };

/** Matches `CryptoAssetCard`'s shell, so the rail ends on the same shape. */
export const TILE_RADIUS = 'lg';

/**
 * Smaller than the deal rail's 32px: these tiles are ~128px tall, so a 32px
 * arrow plus the label would leave almost no breathing room.
 */
export const TILE_ICON_SIZE = '6';

export const EMPTY_MESSAGE = 'No crypto assets available right now.';

/**
 * Must differ from the funded-ventures and growth-stage skeleton labels: all
 * three sit on the same page, and `role="status"` regions sharing a name are
 * ambiguous to assistive tech and to `getByRole`.
 */
export const LOADING_LABEL = 'Loading popular crypto assets';
